









































import { Component, Vue, Watch } from "vue-property-decorator";
import { ActionTypes } from "@/store/aciton-types";
import UploadAvatarComponent from "@/components/UploadAvatarComponent.vue";
import { UserItem } from "@/response";

@Component({
  components: {
    UploadAvatarComponent
  }
})
export default class ProfileComponent extends Vue {
  get user() {
    try {
      return this.$store.state.userStore.profile;
    } catch (error) {
      return <UserItem>{};
    }
  }

  logoutUser() {
    this.$store.dispatch(ActionTypes.LOGOUT).then(success => {
      console.log('logout success')
      this.$router.replace({ name: "login" });
    })
  }

  // Object.keys(this.$store.state.profile).length === 0
  beforeMount() {}
}
